import styled from 'styled-components';
import Chart from './Chart';
import useGetMetricsGraph from 'pages/PatientRecordPage/hooks/useGetMetricsGraph';
import LoadingPage from 'components/LoadingPage';
import { useMetricTranslation } from 'lib/hooks/useMetricTranslation';
import { useTranslation } from 'react-i18next';

const Content = ({
  patient,
  metricDefinitionId,
  debouncedFilter,
  handleChooseAnswer,
  title,
  yAxesOptions,
  scoreType,
}) => {
  const { getTranslatedTitle } = useMetricTranslation();
  const { i18n: i18nFromContent } = useTranslation();
  const { data, loading } = useGetMetricsGraph({
    patient: patient.id,
    metricDefinitionId,
    filter: debouncedFilter,
  });

  const metric =
    data?.items?.find(
      (item) => item?.metricDefinitionId === metricDefinitionId
    ) || [];

  const { unit, graphData, metricDefinition } = metric;
  const unitCode = unit;

  // Use translated title from metric data if available, otherwise use passed title
  const displayTitle = metricDefinition
    ? getTranslatedTitle(metricDefinition, metricDefinition.title || title)
    : title;

  return loading ? (
    <LoadingPage style={{ height: 492 }} />
  ) : !graphData || graphData.length === 0 ? (
    <SWrapper>
      <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
        No data available for this metric
      </div>
    </SWrapper>
  ) : (
    <SWrapper>
      <Chart
        yAxesOptions={yAxesOptions}
        data-id="chart"
        state={{ graphData, unit, title: displayTitle, scoreType: scoreType || 'RISK', unitCode }}
        handleChooseAnswer={handleChooseAnswer}
      />
    </SWrapper>
  );
};

const SWrapper = styled.div`
  && {
    margin-top: 20px;
    display: flex;
    width: 100%;
    flex-direction: column;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      right: 5%;
      height: 100%;
      width: 1px;
      background-color: ${({ theme }) => theme.palette.colors.gray200};
    }
    canvas {
      width: 93% !important;
    }
  }
`;

export default Content;
